export const REPORT_URL = '/__REPORT__';
export const REPORT_PLACEHOLDER = '__REPORT_PLACEHOLDER__';
